import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: column;

    img {
        width: 78px;
        height: 78px;
        border-radius: 50%;
    }

    span {
        font-size: 11px;
        font-weight: 400;
        margin-top: 7px;
    }
`;

export { Container };